module.exports = __webpack_public_path__ + "static/media/27.b42c49b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/27.png
// module id = 1068
// module chunks = 0